import React, { useContext } from 'react';
import './Results.module.scss';
import Button from 'components/UI/Button';
import { faHome } from '@fortawesome/pro-solid-svg-icons';
import { useHistory } from 'react-router';
import { QuizContext } from 'screens/Quiz/Quiz';
import UpcomingEvents from 'components/UI/UpcomingEvents/UpcomingEvents';
import ContactBar from './components/ContactBar/ContactBar';
import VacanciesBar from './components/VacanciesBar/VacanciesBar';
import ArticlesBar from './components/ArticlesBar/ArticlesBar';

export default function Results() {
    const history = useHistory();
    const { email } = useContext(QuizContext);

    return (
        <>
            <div styleName="inner ">
                <h2>Jouw resultaten</h2>
                <p>
                    Hier staan interessante mogelijkheden waar je alvast naar
                    kunt kijken.{' '}
                    {email === '' && (
                        <>
                            Ook help ik je graag bij de begeleiding voor een
                            passende overstap. Mag ik contact met je opnemen?
                            Laat dan hieronder je mailadres achter.
                        </>
                    )}
                </p>
            </div>
            <div styleName="inner ">
                <h3>Artikelen die bij jou passen</h3>
                <ArticlesBar />
            </div>
            <div styleName="inner ">
                <h3>Komende activiteiten</h3>
                <UpcomingEvents numberOfCards={2} />
            </div>
            <div styleName="inner ">
                <h3>Vacatures die mogelijk bij jou passen</h3>
                <div styleName="vacancies">
                    <VacanciesBar />
                </div>
            </div>
            {email === '' && (
                <div styleName="inner ">
                    <ContactBar />
                </div>
            )}
            <div styleName="button-wrapper">
                <Button
                    color="blue-gray"
                    onClick={() => history.push('/')}
                    icon={faHome}
                >
                    Terug naar home
                </Button>
            </div>
        </>
    );
}
